import { render } from "./CardSocial.vue?vue&type=template&id=59be8ee2&scoped=true"
import script from "./CardSocial.vue?vue&type=script&lang=js"
export * from "./CardSocial.vue?vue&type=script&lang=js"

import "./CardSocial.vue?vue&type=style&index=0&id=59be8ee2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59be8ee2"]])

export default __exports__